module.exports = __webpack_public_path__ + "img/mainPicture.cf322989.png";